import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import GusherContent from "./GusherPumpContent";

class SupplierDetails extends React.Component {
  render() {
    return (
      <div className="col-lg-8 col-md-12">
        <Switch>
          <Route path="/suppliers/gusher/pumps" component={GusherContent} />
          <Route path="/suppliers/gusher">
            <Redirect to="/suppliers/gusher/pumps" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default SupplierDetails;
